import { toast, ToastOptions } from "react-toastify";
import { ReactNode } from "react";

import "react-toastify/dist/ReactToastify.css";

const config: ToastOptions = {
  position: "top-right",
  autoClose: 4000,
  hideProgressBar: false,
  closeOnClick: true,
  rtl: false,
  pauseOnFocusLoss: false,
  draggable: false,
  pauseOnHover: true,
  theme: "light",
};

type AlertType = "error" | "warning" | "info" | "success";

export const notify = (
  type: AlertType,
  // message: string,
  message: ReactNode,
  options?: ToastOptions,
) => {
  const toastConfig = { ...config, ...options };
  switch (type) {
    case "success":
      return toast.success(message, toastConfig);
    case "warning":
      return toast.warn(message, toastConfig);
    case "error":
      return toast.error(message, toastConfig);
    case "info":
      return toast.info(message, toastConfig);

    default:
      break;
  }
};
